import { render, staticRenderFns } from "./DetallesEstudio.vue?vue&type=template&id=1a614889&"
import script from "./DetallesEstudio.vue?vue&type=script&lang=js&"
export * from "./DetallesEstudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports